import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgChallengeFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { d: "M20.447 7.394a1 1 0 0 0 0-1.788l-4.982-2.491A.995.995 0 0 0 15.008 3h-.011A.996.996 0 0 0 14 4v8.429l-2.555 3.649-2.134-2.955a1 1 0 0 0-1.622 0L3.445 19H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-.4L16 12.429V9.618l4.447-2.224Z", fill: color }));
};
export default factorySvgIcon(SvgChallengeFilled);
//# sourceMappingURL=SvgChallengeFilled.js.map